import { PointTooltipProps, ResponsiveLine } from '@nivo/line';
import { AxisTickProps } from '@nivo/axes';
import { DayYTick, DayMonthXAxisTick } from 'dataVisualizations/axis/axis';
import { commonProps } from 'dataVisualizations/heartRateLineGraph/heartRateLineGraphConsts';
import { DayLineTooltip } from 'dataVisualizations/tooltips/tooltips';
import { CustomHoverPoint } from 'dataVisualizations/points/points';
import { LineData } from 'dataVisualizations/types/types';

type DayLineChartProps = {
  data: LineData[];
  gridYValues: number[];
  color: string;
  metricName: string;
  customLabelFormat?: (val: number) => string;
  customYAxisFormat?: (val: number) => string;
  numOfSelectedDays: number;
};

const margins = {
  top: 10, right: 5, bottom: 50, left: 36,
};

function DayLineChart({
  data,
  gridYValues,
  color,
  metricName,
  customLabelFormat,
  customYAxisFormat,
  numOfSelectedDays,
}: DayLineChartProps) {
  return (
    <ResponsiveLine
      {...commonProps}
      data={[{ id: metricName, data }]}
      margin={margins}
      curve="linear"
      yScale={{
        type: 'linear',
        min: gridYValues[0],
        max: gridYValues[gridYValues.length - 1],
      }}
      gridYValues={gridYValues}
      areaBaselineValue={gridYValues[0]}
      axisLeft={{
        tickValues: gridYValues,
        tickSize: 0,
        renderTick: (
          tick: AxisTickProps<number>,
        ) => DayYTick(tick.x, tick.y, tick.value, customYAxisFormat),
      }}
      axisBottom={{
        tickSize: 0,
        renderTick: ({
          x, y, tickIndex, value,
        }: AxisTickProps<string>) => DayMonthXAxisTick({
          tick: {
            x, y, tickIndex, value,
          },
          numOfSelectedDays,
        }),
      }}
      colors={color}
      tooltip={(tooltip: PointTooltipProps) => DayLineTooltip(
        tooltip,
        metricName,
        data.length,
        customLabelFormat,
      )}
      layers={['areas', 'grid', 'axes', 'crosshair', 'lines', CustomHoverPoint, 'slices', 'mesh', 'legends']}
    />
  );
}

export default DayLineChart;
